import { render } from "./CFooter.vue?vue&type=template&id=199c98e4&scoped=true&ts=true"
import script from "./CFooter.ts?vue&type=script&lang=ts"
export * from "./CFooter.ts?vue&type=script&lang=ts"

import "./CFooter.scss?vue&type=style&index=0&id=199c98e4&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-199c98e4"]])

export default __exports__